<template>
    <form autocomplete="off" class="">
        <div class="row gy-3">
            <div class="col-12">
                <label class="form-label" for="inputName">Document name <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="form.name"
                :class="{ 'is-invalid': v$.form.name.$error }"  placeholder="Enter document name" />
                <div v-for="(item, index) in v$.form.name.$errors"
                    :key="index" class="invalid-feedback">
                    <span v-if="item.$message">{{ item.$message }}</span>
                </div>
            </div>
            <div class="col-12">
                <label>Document type <span class="text-danger">*</span></label>
                <multiselect mode="single" searchable valueProp="id" trackBy="title" label="title"
                    :can-clear="false" :can-deselect="false"
                    :loading="isLoading" :class="`${v$.form.category_id.$error ? 'is-invalid' : '' }`"
                    :options="documentTypes"
                    v-model="form.category_id" placeholder="--select --">
                    <template v-slot:option="{ option }">
                        <div class="">
                            <span>{{ option.title }}</span>
                        </div>
                    </template>
                </multiselect>
                <div v-for="(item, index) in v$.form.category_id.$errors" :key="index"
                    class="text-danger small">
                    <span v-if="item.$message">{{ item.$message }}</span>
                </div>
            </div>
            <div class="col-12">
                <label for="path" class="form-label">Upload Certificate <span class="text-danger">*</span></label>
                <attachment-uploader :maxSize="5240000"
                fileUploadType="pdf"
                acceptType="application/pdf"
                @uploadSuccess="addDocument($event)" />
                
                <div v-for="(item, index) in v$.form.path.$errors"
                    :key="index" class="invalid-feedback">
                    <span v-if="item.$message">{{ item.$message }}</span>
                </div>

                <div v-if="form.path" class="mt-3 d-flex">
                    <img width="50" class="me-3" :src="absoluteUrl('/images/file-icons/pdf.svg')"/>
                    <div>
                        <h6 class="mb-1"> {{ form.extension }} - {{ form.size }}</h6>
                        <small class="text-muted">{{ form.name }}</small>
                    </div>
                </div>
            </div> 
            <div class="col-12">
                <div class="d-flex mt-3 justify-content-end">
                    <b-button variant="primary" 
                    @click.prevent="create()"
                     type="button">Submit</b-button>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import { required, helpers, requiredIf } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import AttachmentUploader from './AttachmentUploader.vue';

export default {
    setup() {
        return { v$: useVuelidate() };
    },
    components:{
        AttachmentUploader
    },
    data(){
        return{
            isLoading: false,
            form: {
                category_id: "",
                name: "",
            },

            documentTypes: []
        }
    },
    validations() {
        return {        
            form:{
                category_id: {
                    required: helpers.withMessage("Document type is required", required),
                },
                name: {
                    required: helpers.withMessage("Document name is required", required),
                },
                path: {
                    required: helpers.withMessage("Document path is required", required),
                },
            },
        }
    },
    methods:{
        create() {
            this.v$.$validate().then(result =>{
                if (!result) { this.alertError(this.v$.$errors[0].$message); return };

                this.$store.dispatch("changeLoaderValue", true)
                this.$http.post('/documents/create', this.form)
                .then((response) => {
                    this.$store.dispatch("changeLoaderValue", false)
                    if(response.data.success){
                        this.$emit('addedItem', response.data.data)
                        this.resetForm();
                    }
                })
            })
        },
        addDocument(data){
            this.form = Object.assign({...data}, this.form)
        },
        resetForm(){
            this.v$.$reset()
            this.$emit("closeMe")
        },
        getOptionData(){
            this.isLoading = true
            this.$http.get(this.absoluteApiUrl(`/categories?type=DOCUMENT_TYPE`)).then((response) => {
                this.isLoading = false
                if(response.data.success){
                    this.documentTypes = response.data.data
                }
            })
        }
    },
    created(){
        this.getOptionData();
    }
}
</script>